import "../css/Socials.css";

export default function Socials() {
  const socials = [
    {
      name: "Facebook",
      href: "https://facebook.com",
      iconClass: "fab fa-facebook-square",
    },
    {
      name: "Instagram",
      href: "https://instagram.com",
      iconClass: "fab fa-instagram",
    },
    {
      name: "LinkedIn",
      href: "https://linkedin.com",
      iconClass: "fab fa-linkedin",
    },
    {
      name: "YouTube",
      href: "https://youtube.com",
      iconClass: "fab fa-youtube",
    },
  ];

  return (
    <div className="footer-socials">
      {socials.map(({ name, href, iconClass }) => (
        <a
          key={name}
          href={href}
          aria-label={name}
          title={name}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i aria-hidden="true" className={iconClass}></i>
        </a>
      ))}
    </div>
  );
}
